import { useState } from 'react';
import { webSocketSendGetCurrentForTypes } from 'common/webSocket.requests';
import { Logger } from 'common/logger';
import { useInterval } from '@chakra-ui/react';

const WEBSOCKET_STATE_UPDATE_INTERVAL = 1 * 60 * 1000;

/**
 * We are sending commands to get the current state of the park
 * Websocket initializing is done in bulk in updateWebSocketForParks
 */
export function useParkWebsocket({ parkName, commands }) {
    const [connected, setConnected] = useState(false);

    useInterval(
        () => {
            try {
                if (connected) {
                    // Keep connection alive by sending a message
                    Logger.debug(`Sending keep alive message to websocket for ${parkName}`);
                    webSocketSendGetCurrentForTypes(parkName, ['POWER_PRICE']);
                } else {
                    webSocketSendGetCurrentForTypes(parkName, commands);
                    setConnected(true);
                }
            } catch (err) {
                Logger.debug('Failed to send message to websocket', err);
                setConnected(false);
            }
        },
        connected ? WEBSOCKET_STATE_UPDATE_INTERVAL : 1000
    );

    return connected;
}
